import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Lab = () => {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Lab Tests
        </Typography>
        <Typography variant="body1">
          Lab test booking services coming soon...
        </Typography>
      </Container>
    </Box>
  );
};

export default Lab;
